import { render } from "./statistics.vue?vue&type=template&id=31fee26d&scoped=true"
import script from "./statistics.vue?vue&type=script&lang=js"
export * from "./statistics.vue?vue&type=script&lang=js"

import "./statistics.vue?vue&type=style&index=0&id=31fee26d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31fee26d"

export default script